import { Component, Input, OnInit } from '@angular/core'
import { EventsService } from '../../services/events.service'

import { Event } from '../../models/event.model'

@Component({
  selector: 'ld-event-map',
  template: require('./event-map.component.html'),
  styles: [require('./event-map.component.css')]
})
export class EventMapComponent implements OnInit {
  @Input('event') event: Event
  private coords = {}

  constructor (private eventsService: EventsService) {}

  async ngOnInit () {
    this.coords = await this.eventsService.getCoordinates(this.event)
  }
}



// WEBPACK FOOTER //
// ../~/angular2-template-loader!./app/components/event-map/event-map.component.ts